import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchRewardOrderStatus = createAsyncThunk("fetchRewardOrderStatus", async (user_channel) => {
	const response = await axiosHttp.get(`order/statuses/list?channel_id=${user_channel}`);
	return response.data.data;
});

const RewardOrderStatusSlice = createSlice({
	name: "RewardOrderStatusSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchRewardOrderStatus.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchRewardOrderStatus.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchRewardOrderStatus.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default RewardOrderStatusSlice.reducer;
